import React from 'react';
import { ImageOptimizer } from '@/components/seo/ImageOptimizer';
const TeamImage = () => {
  return (
    <div className="relative">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent rounded-md transform rotate-2"></div>
      <ImageOptimizer 
        src="/uploads/hero-partners-wc.jpg"
        alt="Diverse team of SeniorThrive professionals collaborating in a modern office, showcasing teamwork and dedication"
        className=""
        imgClassName="relative w-full h-[400px] lg:h-[500px] object-cover rounded-md shadow-overlay transform -rotate-1 hover:rotate-0 transition-transform duration-500"
        sizes="(min-width: 1024px) 600px, 100vw"
      />
    </div>
  );
};

export default TeamImage;